// Imports
import Vue from 'vue'
import Router from 'vue-router'
// import { trailingSlash } from '@/util/helpers'
import {
  layout,
  route,
} from '@/util/routes'
import axios from 'axios'

Vue.use(Router)

/**
router.beforeEach((to, from, next) => {
  return to.path.endsWith('/') ? next() : next(trailingSlash(to.path))
})
 */

// const roles = localStorage.getItem('roles')

const routeTree = [
  route('Dashboard', null, '', { role: ['root', 'dispatcher', 'sem', 'sale'] }),
  // Pages
  route('UserProfile', null, 'components/profile', { role: ['root', 'dispatcher', 'sem', 'sale'] }),
  // admins
  route('Admins', null, '/system/admins', { role: ['root', 'dispatcher'] }),
  // 客户管理
  route('Customer', null, '/system/customer', { role: ['root', 'dispatcher', 'sem'] }),
  // 营销数据
  route('Marketing', null, '/marketing', { role: ['root', 'dispatcher', 'sem'] }),
  // 统计报表
  route('Report', null, '/report', { role: ['root', 'dispatcher'] }),
  // roles
  route('Roles', null, '/system/roles', { role: ['root'] }),
  // classify
  // route('Classify', null, '/system/classify', { role: ['root', 'dispatcher'] }),
  // route('Icons', null, 'components/icons', { role: ['root'] }),
]

/*
const routeTreeNew = []

routeTree.map((item, i, arr) => {
  if (item.meta.role.includes(roles)) {
    routeTreeNew[i] = item
  } else {
    console.log(item)
  }
})
*/

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    layout('Default', routeTree),
    // Login
    route('Login', null, '/login'),
  ],
})

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  // console.log(to.meta.role)
  // console.log(roles)
  // 获取用户信息
  axios
  .get(process.env.VUE_APP_BASE_API + '/user/info')
  .then(response => {
    // console.log(response)
    if (response.data.code === 401) {
      localStorage.removeItem('Authorization') // 删除已经失效或过期的token（不删除也可以，因为登录后覆盖）
    }
  })
  .catch(error => {
    console.log(error)
    localStorage.removeItem('Authorization')
    next('/login')
  })

  const token = localStorage.getItem('Authorization')
  // console.log(token)
  if (to.path === '/login' || to.path === '/login/') {
    if (token === null || token === '') {
      next()
    } else {
      next('/')
    }
  } else {
    if (token === null || token === '') {
      next('/login')
    } else {
      next()
    }
  }
})

router.afterEach((to, from, next) => {
  //
})

export default router
